import PostAddIcon from '@mui/icons-material/PostAdd'

const Icon = () => {
  return (
    <PostAddIcon
      htmlColor='rgba(0, 0, 0, 0.54)'
      fontSize='medium'
    />
  )
}

export default Icon
